import actionTypes from '@store/constants/libraDashboard';

const initialState = {
  accounts: {
    isLoading: false,
    isError: false,
    error: null,
    data: { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 },
    selectedAccount: null
  },
  transfers: {
    isLoading: false,
    isError: false,
    error: null,
    data: { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 },
    selectedTransfer: null
  },
  corporateBeneficiaries: {
    isLoading: false,
    isError: false,
    error: null,
    data: { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 },
    selectedCorporateBeneficiary: null
  },
  scheduledTransfers: {
    isLoading: false,
    isError: false,
    error: null,
    data: { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 },
    selectedScheduledTransfer: null
  },
  createAccount: {
    isLoading: false,
    isError: false,
    error: null
  },
  createCorporateBeneficiary: {
    isLoading: false,
    isError: false,
    error: null
  },
  createScheduledTransfer: {
    isLoading: false,
    isError: false,
    error: null
  },
  updateScheduledTransfer: {
    isLoading: false,
    isError: false,
    error: null
  },
  transferActions: {
    isLoading: false,
    isError: false,
    error: null
  },
  libraConfigs: {
    isLoading: false,
    isError: false,
    error: null,
    accounts: [],
    corporateBeneficiaries: []
  }
};

const libraDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // Accounts
    case actionTypes.GET_ACCOUNTS:
      return {
        ...state,
        accounts: { ...state.accounts, isLoading: true, isError: false, error: null }
      };
    case actionTypes.GET_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          isLoading: false,
          data: action.payload || { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 }
        }
      };
    case actionTypes.GET_ACCOUNTS_FAILURE:
      return {
        ...state,
        accounts: { ...state.accounts, isLoading: false, isError: true, error: action.payload }
      };

    case actionTypes.CREATE_ACCOUNT:
      return {
        ...state,
        createAccount: { isLoading: true, isError: false, error: null }
      };
    case actionTypes.CREATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        createAccount: { isLoading: false, isError: false, error: null }
      };
    case actionTypes.CREATE_ACCOUNT_FAILURE:
      return {
        ...state,
        createAccount: { isLoading: false, isError: true, error: action.payload }
      };

    // Transfers
    case actionTypes.GET_TRANSFERS:
      return {
        ...state,
        transfers: { ...state.transfers, isLoading: true, isError: false, error: null }
      };
    case actionTypes.GET_TRANSFERS_SUCCESS:
      return {
        ...state,
        transfers: {
          ...state.transfers,
          isLoading: false,
          data: action.payload || { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 }
        }
      };
    case actionTypes.GET_TRANSFERS_FAILURE:
      return {
        ...state,
        transfers: { ...state.transfers, isLoading: false, isError: true, error: action.payload }
      };

    case actionTypes.CREATE_TRANSFER:
    case actionTypes.PROCESS_TRANSFER:
      return {
        ...state,
        transferActions: { isLoading: true, isError: false, error: null }
      };
    case actionTypes.CREATE_TRANSFER_SUCCESS:
    case actionTypes.PROCESS_TRANSFER_SUCCESS:
      return {
        ...state,
        transferActions: { isLoading: false, isError: false, error: null }
      };
    case actionTypes.CREATE_TRANSFER_FAILURE:
    case actionTypes.PROCESS_TRANSFER_FAILURE:
      return {
        ...state,
        transferActions: { isLoading: false, isError: true, error: action.payload }
      };

    // Corporate Beneficiaries
    case actionTypes.GET_CORPORATE_BENEFICIARIES:
      return {
        ...state,
        corporateBeneficiaries: { ...state.corporateBeneficiaries, isLoading: true, isError: false, error: null }
      };
    case actionTypes.GET_CORPORATE_BENEFICIARIES_SUCCESS:
      return {
        ...state,
        corporateBeneficiaries: {
          ...state.corporateBeneficiaries,
          isLoading: false,
          data: action.payload || { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 }
        }
      };
    case actionTypes.GET_CORPORATE_BENEFICIARIES_FAILURE:
      return {
        ...state,
        corporateBeneficiaries: { ...state.corporateBeneficiaries, isLoading: false, isError: true, error: action.payload }
      };

    case actionTypes.CREATE_CORPORATE_BENEFICIARY:
      return {
        ...state,
        createCorporateBeneficiary: { isLoading: true, isError: false, error: null }
      };
    case actionTypes.CREATE_CORPORATE_BENEFICIARY_SUCCESS:
      return {
        ...state,
        createCorporateBeneficiary: { isLoading: false, isError: false, error: null }
      };
    case actionTypes.CREATE_CORPORATE_BENEFICIARY_FAILURE:
      return {
        ...state,
        createCorporateBeneficiary: { isLoading: false, isError: true, error: action.payload }
      };

    // UI State
    case actionTypes.SET_SELECTED_ACCOUNT:
      return {
        ...state,
        accounts: { ...state.accounts, selectedAccount: action.payload }
      };
    case actionTypes.SET_SELECTED_TRANSACTION:
      return {
        ...state,
        transactions: { ...state.transactions, selectedTransaction: action.payload }
      };
    case actionTypes.SET_SELECTED_SWEEPOUT:
      return {
        ...state,
        sweepouts: { ...state.sweepouts, selectedSweepout: action.payload }
      };
    case actionTypes.SET_SELECTED_TRANSFER:
      return {
        ...state,
        transfers: { ...state.transfers, selectedTransfer: action.payload }
      };
    case actionTypes.SET_SELECTED_CLIENT:
      return {
        ...state,
        clients: { ...state.clients, selectedClient: action.payload }
      };
    case actionTypes.SET_SELECTED_LIABILITY:
      return {
        ...state,
        liabilities: { ...state.liabilities, selectedLiability: action.payload }
      };
    case actionTypes.SET_SELECTED_CORPORATE_BENEFICIARY:
      return {
        ...state,
        corporateBeneficiaries: { ...state.corporateBeneficiaries, selectedCorporateBeneficiary: action.payload }
      };

    // Scheduled Transfers
    case actionTypes.GET_SCHEDULED_TRANSFERS:
      return {
        ...state,
        scheduledTransfers: { ...state.scheduledTransfers, isLoading: true, isError: false, error: null }
      };
    case actionTypes.GET_SCHEDULED_TRANSFERS_SUCCESS:
      return {
        ...state,
        scheduledTransfers: {
          ...state.scheduledTransfers,
          isLoading: false,
          data: action.payload || { items: [], maxPages: 1, totalItems: 0, pageNumber: 0, pageSize: 10 }
        }
      };
    case actionTypes.GET_SCHEDULED_TRANSFERS_FAILURE:
      return {
        ...state,
        scheduledTransfers: { ...state.scheduledTransfers, isLoading: false, isError: true, error: action.payload }
      };

    case actionTypes.CREATE_SCHEDULED_TRANSFER:
      return {
        ...state,
        createScheduledTransfer: { isLoading: true, isError: false, error: null }
      };
    case actionTypes.CREATE_SCHEDULED_TRANSFER_SUCCESS:
      return {
        ...state,
        createScheduledTransfer: { isLoading: false, isError: false, error: null }
      };
    case actionTypes.CREATE_SCHEDULED_TRANSFER_FAILURE:
      return {
        ...state,
        createScheduledTransfer: { isLoading: false, isError: true, error: action.payload }
      };

    case actionTypes.UPDATE_SCHEDULED_TRANSFER:
      return {
        ...state,
        updateScheduledTransfer: { isLoading: true, isError: false, error: null }
      };
    case actionTypes.UPDATE_SCHEDULED_TRANSFER_SUCCESS:
      return {
        ...state,
        updateScheduledTransfer: { isLoading: false, isError: false, error: null }
      };
    case actionTypes.UPDATE_SCHEDULED_TRANSFER_FAILURE:
      return {
        ...state,
        updateScheduledTransfer: { isLoading: false, isError: true, error: action.payload }
      };

    case actionTypes.SET_SELECTED_SCHEDULED_TRANSFER:
      return {
        ...state,
        scheduledTransfers: { ...state.scheduledTransfers, selectedScheduledTransfer: action.payload }
      };

    case actionTypes.CLEAR_LIBRA_STATE:
      return initialState;

    // Libra Dashboard Configs
    case actionTypes.GET_LIBRA_DASHBOARD_CONFIGS:
      return {
        ...state,
        libraConfigs: { ...state.libraConfigs, isLoading: true, isError: false, error: null }
      };
    case actionTypes.GET_LIBRA_DASHBOARD_CONFIGS_SUCCESS:
      return {
        ...state,
        libraConfigs: {
          ...state.libraConfigs,
          isLoading: false,
          accounts: action.payload?.accounts || [],
          corporateBeneficiaries: action.payload?.corporateBeneficiaries || []
        }
      };
    case actionTypes.GET_LIBRA_DASHBOARD_CONFIGS_FAILURE:
      return {
        ...state,
        libraConfigs: { ...state.libraConfigs, isLoading: false, isError: true, error: action.payload }
      };

    default:
      return state;
  }
};

export default libraDashboardReducer;
